export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <g transform="translate(32 32)" fill="currentColor">
      {[0, 72, 144, 216, 288].map((r) => (
        <ellipse key={r} cx="0" cy="-13" rx="8" ry="13" transform={`rotate(${r})`} />
      ))}
    </g>
    <circle cx="32" cy="32" r="4.5" fill="#07090A" />
  </svg>
);
